<i18n>
{
  "fr": {
    "searchProperty": "Chercher une propiété",
    "createProperty": "Créer une propriété",
    "streetLabel": "Rue",
    "street": "Rue",
    "town": "Commune",
    "streetNumber": "Numéro de police",
    "properties": "propriétés",
    "folderNumber": "N° dossier",
    "folderNumberPlaceholder": "Numéro du dossier",
    "requestType": "Type",
    "requestTypePlaceholder": "Type de visite",
    "dateOfVisit": "Date de visite",
     "dateOfVisitRange": "Date de visite entre :",
    "dateOfVisitPlaceholder": "Date de visite",
    "status": "Etat",
    "statusPlaceholder": "Etat",
    "reset": "Réinitialiser",
    "filter": "Filtrer",
    "complianceSurveyOnly": "Enquête de conformité seule",
    "addressNumber" : "N°",
    "addressStreet" : "Rue",
    "addressStreetPlaceholder": "rue",
    "protractor": "Rapporteur",
    "protractorPlaceholder": "Rapporteur",
    "reasonForControl": "Motif de contrôle"
  }
}
</i18n>
<template>
  <form class="search w-100" @submit.prevent="handleSubmitSearch" v-on:keyup.enter="handleOnKeyEnter()">
    <b-row>
      <div class="col-sm-6 user-filter border-right">
        <div class="form-group">
          <label class="control-label" for="folderNumber">{{ $t('folderNumber') }}</label>
          <div class="input-group">
            <input
              type="text"
              :maxlength="$MAX_255"
              v-model="search.folderNumber"
              class="form-control"
              :placeholder="$t('folderNumberPlaceholder')"
            />
          </div>
        </div>

        <div class="form-group">
          <div>
            <div class="form-group">
              <label class="control-label" for="motifTypes">{{ $t('reasonForControl') }}</label>
              <div class="input-group">
                <b-form-select v-model="search.motifTypes" :options="motifTypes" />
              </div>
            </div>
          </div>

          <div class="row mg-0">
            <div class="col-6 pd-0">
              <label class="control-label" for="dateOfVisitFrom">{{ $t('dateOfVisitRange') }}</label>
              <div class="input-group">
                <input
                  type="date"
                  v-model="search.dateOfVisitFrom"
                  class="form-control"
                  :placeholder="$t('dateOfVisitPlaceholder')"
                />
              </div>
            </div>

            <div class="col-6 pd-r-0">
              <label class="control-label" for="dateOfVisitTo">Et</label>
              <div class="input-group">
                <input
                  type="date"
                  v-model="search.dateOfVisitTo"
                  class="form-control"
                  :placeholder="$t('dateOfVisitPlaceholder')"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label class="control-label" for="townProperty">{{ $t('town') }}</label>
          <div class="input-group"></div>
          <multiselect
            id="townProperty"
            v-model="search.town"
            name="townProperty"
            :options="getTowns"
            track-by="id"
            label="label"
            deselect-label
            select-label
            :custom-label="customLabel"
          />
        </div>
      </div>
      <div class="col-sm-6 user-filter border-right">
        <div class="form-group">
          <label class="control-label" for="requestType">{{ $t('requestType') }}</label>
          <div class="input-group"></div>
          <b-form-select v-model="search.requestType" :options="controleTtpes"></b-form-select>
        </div>
        <div class="form-group">
          <label class="control-label" for="status">{{ $t('status') }}</label>
          <div class="input-group">
            <b-form-select v-model="search.status" :options="status"></b-form-select>
          </div>
        </div>
        <div class="d-flex form-group">
          <div class="align-self-end col-sm-2 pd-0">
            <label class="control-label" for="addressNumber">{{ $t('addressNumber') }}</label>
            <div class="input-group">
              <input
                type="text"
                :maxlength="$MAX_255"
                v-model="search.addressNumber"
                class="form-control"
                :placeholder="$t('addressNumber')"
              />
            </div>
          </div>
          <div class="align-self-end col-sm-10 pd-0">
            <label class="control-label" for="addressStreet">{{ $t('addressStreet') }}</label>
            <div class="input-group">
              <input
                type="text"
                :maxlength="$MAX_255"
                v-model="search.addressStreet"
                class="form-control"
                :placeholder="$t('addressStreetPlaceholder')"
              />
            </div>
          </div>
        </div>
        <div class="form-group">
          <label class="control-label" for="protractor">{{ $t('protractor') }}</label>
          <div class="input-group">
            <input
              type="text"
              :maxlength="$MAX_255"
              v-model="search.protractor"
              class="form-control"
              :placeholder="$t('protractorPlaceholder')"
            />
          </div>
        </div>
      </div>
    </b-row>
    <b-row class="clearfix">
      <div class="col-sm-12 text-right filter-actions">
        <button class="reset-form btn" type="reset" @click="handleClickReset">
          <i class="fa fa-trash" aria-hidden="true"></i>
          {{ $t('reset') }}
        </button>
        <button
          type="submit"
          class="btn btn-primary ladda-stop"
          id="filter-submit"
          value="filter"
          v-on:keyup.enter="handleOnKeyEnter"
        >
          <i class="fa fa-filter" aria-hidden="true"></i>
          <span>{{ $t('filter') }}</span>
        </button>
      </div>
    </b-row>
  </form>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { MOTIF_TYPES } from '../constants/conformite';
export default {
  name: 'Search',

  components: {},

  data() {
    return {
      filtreRequestType: [],
      loaderData: false,
      complianceSurveyOnly: null,
      motifTypes: MOTIF_TYPES,
      controleTtpes: [
        { value: null, text: '--Type de contrôles--' },
        { value: 'CONFORMITE', text: 'Conformité' },
        { value: 'VE', text: "Visite d'Entretien" },
        { value: 'VPT', text: 'Visite Pendant Travaux' },
      ],
      status: [
        {
          value: null,
          text: '--Etat--',
        },
        {
          value: 'new',
          text: 'Nouveau',
        },
        {
          value: 'inProgress',
          text: 'En cours',
        },
        {
          value: 'waitingForValidation',
          text: 'A valider',
        },

        {
          value: 'validated',
          text: 'Validé',
        },
        {
          value: 'generatedMail',
          text: 'Courrier généré',
        },
        {
          value: 'closed',
          text: 'Clôturé',
        },
      ],
    };
  },

  created() {
    window.addEventListener('keypress', this.handleOnKeyEnter);
  },
  beforeDestroy() {
    window.removeEventListener('keypress', this.handleOnKeyEnter);
  },
  computed: {
    ...mapState({ search: (state) => state.controlsList.search }),
    ...mapGetters(['getTowns']),
  },
  mounted: function () {
    if (this.getTowns.length == 0) {
      this.loaderData = true;
      this.fetchTowns();
    }
  },

  methods: {
    customLabel({ label }) {
      return label.toUpperCase();
    },
    fetchTowns() {
      this.$store.dispatch('fetchTowns').then(() => (this.loaderData = false));
    },
    handleSubmitSearch() {
      this.$store.dispatch('fetchControlsList');
    },
    handleClickReset() {
      this.search.town = {};
      this.$store.dispatch('resetSearchControlsList');
      this.$store.dispatch('fetchControlsList');
    },
    handleOnKeyEnter(event) {
      /**
       *
       * if the enter key is activated,
       * then run the filter
       *
       */
      if( event.which ){
        if (event.which == 13) {
          event.preventDefault();
          this.$store.dispatch('fetchControlsList');
        }
      }
    },
  },
};
</script>

